export const variants = {
  primary: "bg-primary text-white hover:bg-opacity-80 focus:ring-primary",
  secondary: "bg-secondary text-white hover:bg-opacity-80 focus:ring-secondary",
  darkblue: "bg-darkblue text-white hover:bg-opacity-80 focus:ring-darkblue",
  lightblue:
    "bg-lightblue text-darkBlue hover:text-opacity-80 focus:ring-darkblue",
  mono: "text-black bg-transparent hover:bg-primary hover:bg-opacity-20 hover:text-primary focus:ring-primary",
  danger:
    "text-white bg-danger hover:bg-danger hover:bg-opacity-80 focus:ring-danger",
  success:
    "text-white bg-success hover:bg-success hover:bg-opacity-80 focus:ring-success",
  fuchsia:
    "text-white bg-fuchsia hover:bg-fuchsia hover:bg-opacity-80 focus:ring-fuchsia",
  blue: "text-white bg-blue hover:bg-blue hover:bg-opacity-80 focus:ring-blue",
  dark: "text-white bg-dark hover:bg-dark hover:bg-opacity-80 focus:ring-dark",
  light:
    "text-gray-500 border-2 border-gray-300 bg-light hover:bg-light hover:bg-opacity-80 focus:ring-light",
  info: "text-white bg-info hover:bg-info hover:bg-opacity-80 focus:ring-info",
  lightInfo:
    "text-gray-500 bg-light border hover:border-info hover:bg-info focus:ring-info hover:text-white focus:bg-info focus:text-white focus:border-info",
  lightWarning:
    "text-gray-500 bg-light border hover:border-warning hover:bg-warning focus:ring-warning hover:text-white focus:bg-warning focus:text-white focus:border-warning",
  lightSuccess:
    "text-gray-500 bg-light border hover:border-success hover:bg-success focus:ring-success hover:text-white focus:bg-success focus:text-white focus:border-success",
  lightPrimary:
    "text-gray-500 bg-light border hover:border-primary hover:bg-primary focus:ring-primary hover:text-white focus:bg-primary focus:text-white focus:border-primary",
  lightDarkblue:
    "text-gray-500 bg-light border hover:border-darkblue hover:bg-darkblue focus:ring-darkblue hover:text-white focus:bg-darkblue focus:text-white focus:border-darkblue",
  lightGray:
    "text-gray-500 bg-light border hover:border-gray-300 hover:bg-gray-300 focus:ring-gray-300 focus:bg-gray-300 hover:text-gray-600 focus:text-gray-600 focus:border-gray-300",
  outlineDanger:
    "text-danger bg-danger bg-opacity-20 border border-danger border-opacity-30 hover:border-danger hover:bg-danger focus:ring-danger hover:text-white focus:bg-danger focus:text-white focus:border-danger",
};

export const loadingVariants = {
  primary: "bg-primary text-white hover:bg-opacity-80 focus:ring-primary",
  secondary: "bg-secondary text-white hover:bg-opacity-80 focus:ring-secondary",
  darkblue: "bg-darkblue text-white hover:bg-opacity-80 focus:ring-darkblue",
  lightblue:
    "bg-lightblue text-darkBlue hover:text-opacity-80 focus:ring-darkblue",
  mono: "text-black bg-transparent hover:bg-primary hover:bg-opacity-20 hover:text-primary focus:ring-primary",
  danger:
    "text-white bg-danger hover:bg-danger hover:bg-opacity-80 focus:ring-danger",
  success:
    "text-white bg-success hover:bg-success hover:bg-opacity-80 focus:ring-success",
  fuchsia:
    "text-white bg-fuchsia hover:bg-fuchsia hover:bg-opacity-80 focus:ring-fuchsia",
  blue: "text-white bg-blue hover:bg-blue hover:bg-opacity-80 focus:ring-blue",
  info: "text-white bg-info hover:bg-info hover:bg-opacity-80 focus:ring-info",
  dark: "text-white bg-dark hover:bg-dark hover:bg-opacity-80 focus:ring-dark",
  light:
    "text-gray-500 border-2 border-gray-300 bg-light hover:bg-light hover:bg-opacity-80 focus:ring-light",
  lightInfo:
    "text-gray-500 bg-light border hover:border-info hover:bg-info focus:ring-info hover:text-white focus:bg-info focus:text-white focus:border-info",
  lightWarning:
    "text-gray-500 bg-light border hover:border-warning hover:bg-warning focus:ring-warning hover:text-white focus:bg-warning focus:text-white focus:border-warning",
  lightSuccess: "border border-success bg-success text-white",
  lightPrimary: "border border-primary bg-primary text-white",
  lightDarkblue:
    "text-gray-500 bg-light border hover:border-darkblue hover:bg-darkblue focus:ring-darkblue hover:text-white focus:bg-darkblue focus:text-white focus:border-darkblue",
  lightGray:
    "text-gray-500 bg-light border hover:border-gray-300 hover:bg-gray-300 focus:ring-gray-300 focus:bg-gray-300 hover:text-gray-600 focus:text-gray-600 focus:border-gray-300",
  outlineDanger:
    "text-danger bg-light border hover:border-danger hover:bg-danger focus:ring-danger hover:text-white focus:bg-danger focus:text-white focus:border-danger",
};
